export default "__VITE_ASSET__CTVTQ2pV__"